module.exports = __webpack_public_path__ + "images/panorama-aa53ba7eb42bcdbac3c4fd5d023ea827.jpg";